"use client"
 
const PasswordEyeIcon = ({ isVisible }) => {
  return isVisible ? (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
<path
        d="M2.5 10C2.5 10 5 4.5 10 4.5C15 4.5 17.5 10 17.5 10C17.5 10 15 15.5 10 15.5C5 15.5 2.5 10 2.5 10Z"
        stroke="#6B7280"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
<path
        d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
        stroke="#6B7280"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
</svg>
  ) : (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
<path
        d="M14.95 14.95C13.5255 16.0358 11.7909 16.6374 10 16.6667C5 16.6667 2.5 10 2.5 10C3.49489 7.94617 4.96184 6.17076 6.75 4.83333M8.25 3.53333C8.82378 3.39907 9.41078 3.33195 10 3.33333C15 3.33333 17.5 10 17.5 10C17.0111 10.9463 16.4396 11.8373 15.7917 12.6583"
        stroke="#6B7280"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
<path
        d="M11.7667 11.7667C11.5378 12.0123 11.2618 12.2093 10.9552 12.3459C10.6485 12.4826 10.3174 12.5563 9.98178 12.5628"
        stroke="#6B7280"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
<path
        d="M2.5 2.5L17.5 17.5"
        stroke="#6B7280"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
</svg>
  )
}
 
export default PasswordEyeIcon